import React, { useMemo, useEffect, useRef, useState } from "react";
import "./assets/css/home.css";

import menuData from "./assets/menu-data";

import Programmes from "./home-components/Programmes";
import Alumni from "./home-components/Alumni";
import Recruiters from "./home-components/Recruiters";
import Awards from "./home-components/Awards";
import Facilities from "./home-components/Facilities";
import BlogsFAQ from "./home-components/BlogsFAQ";
import Footer from "./components/Footer";

import logo from "./assets/img/logo.webp";
import logoWhite from "./assets/img/logo-white.webp";

import banner1 from "./assets/img/banner-1.png";
import banner2 from "./assets/img/banner-2.png";
import banner3 from "./assets/img/banner-3.png";
import banner4 from "./assets/img/banner-4.png";
import banner5 from "./assets/img/banner-5.png";

import about1 from "./assets/img/about-1.webp";
import about2 from "./assets/img/about-2.webp";

import p1 from "./assets/img/programs/Research-and-Development.jpg";
import p2 from "./assets/img/programs/Post-Graduation.jpg";
import p3 from "./assets/img/programs/Graduation.jpg";
import p4 from "./assets/img/programs/diploma.jpg";
import p5 from "./assets/img/programs/Certificate.jpg";

import arrow from "./assets/img/programs/arrow.webp";
import naacLogo from "./assets/img/rec/naac.webp";
import aiuLogo from "./assets/img/rec/aiu.webp";
import aacsbLogo from "./assets/img/rec/aacsb.png";
import ugcLogo from "./assets/img/rec/ugc.png";
import aicteLogo from "./assets/img/rec/aicte.webp";
import bciLogo from "./assets/img/rec/bci.webp";
import pciLogo from "./assets/img/rec/pci.webp";
import engineeringImg from "./assets/img/schoolbanner/schoolofeng.webp";
import managementImg from "./assets/img/schoolbanner/schoolofeng.webp";
import lawImg from "./assets/img/schoolbanner/schoolofeng.webp";
import pharmacyImg from "./assets/img/schoolbanner/schoolofeng.webp";
import scienceImg from "./assets/img/schoolbanner/schoolofeng.webp";

import abertayLogo from "./assets/img/partnership/abertay.png";
import diuLogo from "./assets/img/partnership/diu.webp";
import henryLogo from "./assets/img/partnership/henry.webp";
import indianaLogo from "./assets/img/partnership/indiana.webp";
import rushfordLogo from "./assets/img/partnership/rushford.webp";
import placement1 from "./assets/img/placement/placement1.jpeg";
import placement2 from "./assets/img/placement/placement2.jpg";
import placement3 from "./assets/img/placement/placement3.jpg";
import placement4 from "./assets/img/placement/placement4.jpg";


const placementGallery = [placement1, placement2, placement3, placement4];

const placementStats = [
  {
    value: 6500,
    suffix: "+",
    label: "Placements",
  },
  {
    value: 45,
    suffix: " LPA",
    label: "Highest Offer",
  },
  {
    value: 25,
    suffix: " LPA",
    label: "Average Offer",
  },
  {
    value: 250,
    suffix: "+",
    label: "Companies Hired",
  },
  {
    value: 150,
    suffix: "+",
    label: "Companies Visited",
  },
  {
    value: 95,
    suffix: "%",
    label: "Students Placed",
  },
];

function AnimatedStat({ value, suffix = "", duration = 1800, label, index }) {
  const counterRef = useRef(null);
  const [displayValue, setDisplayValue] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const element = counterRef.current;

    if (!element) return undefined;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (prefersReducedMotion) {
      setDisplayValue(value);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.35,
      },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [hasStarted, value]);

  useEffect(() => {
    if (!hasStarted) return undefined;

    let animationFrame;
    let startTime;

    const animateCounter = (timestamp) => {
      if (!startTime) startTime = timestamp;

      const elapsedTime = timestamp - startTime;
      const progress = Math.min(elapsedTime / duration, 1);

      // Smooth ease-out animation
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.floor(easedProgress * value);

      setDisplayValue(currentValue);

      if (progress < 1) {
        animationFrame = window.requestAnimationFrame(animateCounter);
      } else {
        setDisplayValue(value);
      }
    };

    animationFrame = window.requestAnimationFrame(animateCounter);

    return () => window.cancelAnimationFrame(animationFrame);
  }, [hasStarted, value, duration]);

  return (
    <article
      className="placement-stat"
      ref={counterRef}
      style={{ "--stat-delay": `${index * 70}ms` }}
    >
      <span className="placement-stat__number" aria-hidden="true">
        {String(index + 1).padStart(2, "0")}
      </span>

      <h3>
        {displayValue.toLocaleString("en-IN")}
        <small>{suffix}</small>
      </h3>

      <span className="placement-stat__label">{label}</span>
    </article>
  );
}

const utilityLinks = [
  { title: "Student Login", url: "/student-login" },
  { title: "NAAC", url: "/naac" },
  { title: "IQAC", url: "/iqac" },
  { title: "e-Library", url: "/e-library" },
  { title: "Ph.D Research", url: "/phd-research" },
  { title: "Pay Online", url: "/pay-online" },
];

const slides = [
  {
    kicker: "Admissions open • 2026",
    title: (
      <>
        Where ambition
        <br />
        <em>finds direction.</em>
      </>
    ),
    text: "Discover an education that challenges convention, builds character and prepares you to lead in a changing world.",
    primary: "Apply for 2026",
    secondary: "Explore programmes",
    image: banner1,
    alt: "University students walking across a historic campus",
  },
  {
    kicker: "A future-forward university",
    title: (
      <>
        Learn boldly.
        <br />
        <em>Lead globally.</em>
      </>
    ),
    text: "Interdisciplinary learning, industry-connected programmes and a community driven by ideas that matter.",
    primary: "Discover ISBMU",
    secondary: "Plan a visit",
    image: banner2,
    alt: "Students collaborating outdoors",
  },
  {
    kicker: "Research with purpose",
    title: (
      <>
        Ideas that move
        <br />
        <em>the world forward.</em>
      </>
    ),
    text: "Work alongside curious minds to create knowledge, solve real problems and make a lasting contribution.",
    primary: "Explore research",
    secondary: "Meet our faculty",
    image: banner3,
    alt: "Researchers working in a modern laboratory",
  },
  {
    kicker: "Research with purpose",
    title: (
      <>
        Ideas that move
        <br />
        <em>the world forward.</em>
      </>
    ),
    text: "Work alongside curious minds to create knowledge, solve real problems and make a lasting contribution.",
    primary: "Explore research",
    secondary: "Meet our faculty",
    image: banner4,
    alt: "Researchers working in a modern laboratory",
  },
  {
    kicker: "Research with purpose",
    title: (
      <>
        Ideas that move
        <br />
        <em>the world forward.</em>
      </>
    ),
    text: "Work alongside curious minds to create knowledge, solve real problems and make a lasting contribution.",
    primary: "Explore research",
    secondary: "Meet our faculty",
    image: banner5,
    alt: "Researchers working in a modern laboratory",
  },
];

const recognitions = [
  {
    mark: "NAAC",
    title: "NAAC Accredited University",
    description:
      "Recognized for academic excellence and quality education in India.",
  },
  {
    mark: "AACSB",
    title: "AACSB Business Education Alliance",
    description: "Globally aligned with leading business education standards.",
  },
  {
    mark: "IAU",
    title: "International Association of Universities",
    description: "Connected to a worldwide higher-education community.",
  },
];

const differentiators = [
  {
    icon: "briefcase",
    title: "Startup Incubation and Placements",
    description:
      "Ideas, mentoring and industry pathways that turn ambition into opportunity.",
  },
  {
    icon: "globe",
    title: "International Academic Programmes",
    description:
      "Globally relevant learning experiences and academic collaborations.",
  },
  {
    icon: "shield",
    title: "Skill Development",
    description:
      "Practical capabilities shaped through projects, workshops and mentoring.",
  },
  {
    icon: "graduation",
    title: "Career Readiness & Soft Skills",
    description:
      "Professional confidence, communication and workplace preparation.",
  },
];

const universityStats = [
  {
    value: "18+",
    label: "Specialized schools offering future-focused programmes",
  },
  {
    value: "200+",
    label: "Professionals dedicated to academic and career success",
  },
  { value: "5000+", label: "Applicants trust ISBM University every year" },
  {
    value: "100+",
    label: "Leading companies actively recruiting our graduates",
  },
];

const newsletters = [
  {
    issue: "Issue 08",
    season: "July 2026",
    title: "Campus Chronicle",
    description:
      "A monthly collection of academic achievements, student activities, research updates and stories from across the University.",
    image:
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=1200&q=88",
    link: "/newsletters/campus-chronicle-july-2026",
    featured: true,
  },
  {
    issue: "Issue 07",
    season: "June 2026",
    title: "Research & Innovation Digest",
    description:
      "Highlights from research, faculty contributions and innovation-led learning.",
    image:
      "https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=900&q=85",
    link: "/newsletters/research-digest-june-2026",
  },
  {
    issue: "Issue 06",
    season: "May 2026",
    title: "Student Success Bulletin",
    description:
      "Celebrating student projects, competitions, placements and campus milestones.",
    image:
      "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=900&q=85",
    link: "/newsletters/student-success-may-2026",
  },
  {
    issue: "Issue 05",
    season: "April 2026",
    title: "Industry Connect",
    description:
      "Workshops, expert sessions, academic collaborations and career-focused initiatives.",
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&q=85",
    link: "/newsletters/industry-connect-april-2026",
  },
];

const events = [
  {
    day: "12",
    month: "AUG",
    year: "2026",
    category: "Orientation",
    title: "New Student Orientation Programme 2026",
    location: "University Auditorium",
    time: "10:00 AM onwards",
    description:
      "A welcoming introduction to academics, campus services, student life and the University community.",
    image:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1000&q=85",
    link: "/events/student-orientation-2026",
  },
  {
    day: "24",
    month: "AUG",
    year: "2026",
    category: "Academic",
    title: "Future Skills and Emerging Careers Conclave",
    location: "Seminar Hall",
    time: "11:00 AM",
    description:
      "Industry professionals and academicians discuss evolving skills, technology and new career pathways.",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1000&q=85",
    link: "/events/future-skills-conclave",
  },
  {
    day: "05",
    month: "SEP",
    year: "2026",
    category: "Student Life",
    title: "University Cultural and Literary Fest",
    location: "Main Campus",
    time: "09:30 AM onwards",
    description:
      "A celebration of creativity, expression and student talent through cultural and literary activities.",
    image:
      "https://images.unsplash.com/photo-1505236858219-8359eb29e329?auto=format&fit=crop&w=1000&q=85",
    link: "/events/university-cultural-fest",
  },
  {
    day: "18",
    month: "SEP",
    year: "2026",
    category: "Careers",
    title: "Career Readiness and Placement Workshop",
    location: "Training & Placement Cell",
    time: "02:00 PM",
    description:
      "Practical sessions on professional communication, aptitude, interviews and career preparation.",
    image:
      "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1000&q=85",
    link: "/events/career-readiness-workshop",
  },
];

const circulars = [
  {
    date: "22 Jul 2026",
    type: "Academic",
    title: "Academic Calendar and Semester Activity Schedule",
    ref: "ISBMU/ACAD/2026/042",
    format: "PDF",
    link: "/circulars/academic-calendar-2026",
  },
  {
    date: "18 Jul 2026",
    type: "Examination",
    title: "Guidelines for Internal Assessment and Project Submission",
    ref: "ISBMU/EXAM/2026/039",
    format: "PDF",
    link: "/circulars/internal-assessment-guidelines",
  },
  {
    date: "10 Jul 2026",
    type: "Student Services",
    title: "Student Identity Card and Campus Access Instructions",
    ref: "ISBMU/ADMIN/2026/035",
    format: "PDF",
    link: "/circulars/campus-access-instructions",
  },
  {
    date: "02 Jul 2026",
    type: "Library",
    title: "Library Membership and Digital Resource Access",
    ref: "ISBMU/LIB/2026/031",
    format: "PDF",
    link: "/circulars/library-resource-access",
  },
];

const notices = [
  {
    date: "25",
    month: "JUL",
    tag: "New",
    title: "Registration Open for Student Clubs and Committees",
    description:
      "Students may submit their preferences through the student services desk.",
    link: "/notices/student-club-registration",
  },
  {
    date: "21",
    month: "JUL",
    tag: "Important",
    title: "Document Verification Schedule for Newly Admitted Students",
    description:
      "Students should report with original documents and the admission acknowledgement.",
    link: "/notices/document-verification-schedule",
  },
  {
    date: "16",
    month: "JUL",
    tag: "Campus",
    title: "Hostel Reporting and Accommodation Guidelines",
    description:
      "Residential students are requested to review reporting dates and hostel instructions.",
    link: "/notices/hostel-reporting-guidelines",
  },
  {
    date: "08",
    month: "JUL",
    tag: "Careers",
    title: "Applications Invited for Career Development Workshops",
    description:
      "Limited seats are available for programme-specific career preparation sessions.",
    link: "/notices/career-development-workshops",
  },
];

function SectionHeading({ eyebrow, title, accent, description, link, dark }) {
  return (
    <header className={`info-heading ${dark ? "info-heading--dark" : ""}`}>
      <div>
        <span className="info-eyebrow">
          <i />
          {eyebrow}
        </span>
        <h2>
          {title}
          <em>{accent}</em>
        </h2>
      </div>
      <div className="info-heading__aside">
        <p>{description}</p>
        <a href={link}>
          View all <span>↗</span>
        </a>
      </div>
    </header>
  );
}

export function NewslettersSection() {
  const featured = newsletters.find((item) => item.featured);
  const archive = newsletters.filter((item) => !item.featured);

  return (
    <section
      className="newsletter-section newsletter-section--no-images"
      aria-labelledby="newsletter-heading"
    >
      <div className="info-container">
        <SectionHeading
          eyebrow="University publications"
          title="Stories from across"
          accent=" our community."
          description="Explore academic developments, student achievements, research highlights and important moments from university life."
          link="/newsletters"
        />

        <div className="newsletter-layout">
          {/* Latest newsletter */}
          <article className="newsletter-featured">
            <div className="newsletter-document-cover">
              <div className="newsletter-document-cover__top">
                <span>ISBM</span>
                <strong>UNIVERSITY</strong>
              </div>

              <div className="newsletter-document-cover__edition">
                <small>{featured.issue}</small>
                <span>{featured.season}</span>
              </div>

              <div className="newsletter-document-cover__title">
                <small>Official University Newsletter</small>
                <h3>{featured.title}</h3>
                <p>Knowledge · Wisdom · Humanity</p>
              </div>

              <span
                className="newsletter-document-cover__mark"
                aria-hidden="true"
              >
                N
              </span>
            </div>

            <div className="newsletter-featured__copy">
              <span>{featured.season} · Latest edition</span>

              <h3>{featured.title}</h3>

              <p>{featured.description}</p>

              <div className="newsletter-featured__meta">
                <div>
                  <small>Publication</small>
                  <strong>{featured.issue}</strong>
                </div>

                <div>
                  <small>Published</small>
                  <strong>{featured.season}</strong>
                </div>
              </div>

              <a href={featured.link}>
                Read latest edition <i>↗</i>
              </a>
            </div>
          </article>

          {/* Previous newsletters */}
          <div className="newsletter-archive">
            <div className="newsletter-archive__label">
              <div>
                <span>Previous editions</span>
                <small>Browse the University newsletter archive</small>
              </div>

              <strong>{String(archive.length).padStart(2, "0")}</strong>
            </div>

            {archive.map((item, index) => (
              <a
                href={item.link}
                className="newsletter-archive__item"
                key={item.title}
              >
                <span className="newsletter-archive__number">
                  {String(index + 2).padStart(2, "0")}
                </span>

                <span
                  className={`newsletter-mini-cover newsletter-mini-cover--${(index % 3) + 1
                    }`}
                  aria-hidden="true"
                >
                  <small>ISBMU</small>
                  <strong>{item.season}</strong>
                  <i>N</i>
                </span>

                <span className="newsletter-archive__copy">
                  <small>
                    {item.issue} · {item.season}
                  </small>

                  <strong>{item.title}</strong>

                  <p>{item.description}</p>
                </span>

                <span className="newsletter-archive__action">
                  View <i>↗</i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function EventsSection() {
  return (
    <section className="events-section" aria-labelledby="events-heading">
      <div className="events-section__pattern" aria-hidden="true">
        EVENTS
      </div>
      <div className="info-container">
        <SectionHeading
          eyebrow="What’s happening"
          title="Meet, participate"
          accent=" and experience."
          description="Discover upcoming academic, cultural and career-focused experiences bringing the university community together."
          link="/events"
          dark
        />

        <div className="events-list">
          {events.map((event, index) => (
            <article className="event-row" key={event.title}>
              <div className="event-row__date">
                <strong>{event.day}</strong>
                <span>{event.month}</span>
                <small>{event.year}</small>
              </div>
              <div className="event-row__image">
                <img src={event.image} alt="" loading="lazy" />
                <span>0{index + 1}</span>
              </div>
              <div className="event-row__content">
                <span>{event.category}</span>
                <h3>{event.title}</h3>
                <p>{event.description}</p>
                <div>
                  <small>⌖ {event.location}</small>
                  <small>◷ {event.time}</small>
                </div>
              </div>
              <a href={event.link} aria-label={`View ${event.title}`}>
                ↗
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CircularsNoticesSection() {
  const [activeType, setActiveType] = useState("All");
  const types = ["All", ...new Set(circulars.map((item) => item.type))];
  const visibleCirculars = useMemo(
    () =>
      activeType === "All"
        ? circulars
        : circulars.filter((item) => item.type === activeType),
    [activeType],
  );

  return (
    <section className="updates-section" aria-labelledby="updates-heading">
      <div className="info-container">
        <SectionHeading
          eyebrow="Official updates"
          title="Stay informed."
          accent=" Stay connected."
          description="Access official university circulars, academic instructions, administrative updates and current notices."
          link="/notices"
        />

        <div className="updates-grid">
          <div className="circular-panel">
            <div className="updates-panel__heading">
              <div>
                <span>Official documents</span>
                <h3>Circulars</h3>
              </div>
              <a href="/circulars">View archive ↗</a>
            </div>
            <div
              className="circular-filters"
              role="tablist"
              aria-label="Filter circulars"
            >
              {types.map((type) => (
                <button
                  key={type}
                  type="button"
                  className={activeType === type ? "active" : ""}
                  aria-selected={activeType === type}
                  onClick={() => setActiveType(type)}
                >
                  {type}
                </button>
              ))}
            </div>
            <div className="circular-list">
              {visibleCirculars.map((item) => (
                <a href={item.link} className="circular-item" key={item.ref}>
                  <span className="circular-item__format">{item.format}</span>
                  <span className="circular-item__copy">
                    <small>
                      {item.date} · {item.type}
                    </small>
                    <strong>{item.title}</strong>
                    <em>{item.ref}</em>
                  </span>
                  <i>↓</i>
                </a>
              ))}
            </div>
          </div>

          <div className="notice-panel">
            <div className="updates-panel__heading">
              <div>
                <span>Student information</span>
                <h3>Notices</h3>
              </div>
              <a href="/notices">View all ↗</a>
            </div>
            <div className="notice-list">
              {notices.map((item) => (
                <a href={item.link} className="notice-item" key={item.title}>
                  <span className="notice-item__date">
                    <strong>{item.date}</strong>
                    <small>{item.month}</small>
                  </span>
                  <span className="notice-item__copy">
                    <small>{item.tag}</small>
                    <strong>{item.title}</strong>
                    <p>{item.description}</p>
                  </span>
                  <i>↗</i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeatureIcon({ type }) {
  if (type === "briefcase") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M8 7V5.7A1.7 1.7 0 0 1 9.7 4h4.6A1.7 1.7 0 0 1 16 5.7V7M4.5 8h15A1.5 1.5 0 0 1 21 9.5v8A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5v-8A1.5 1.5 0 0 1 4.5 8Z" />
        <path d="M3 12.2c5.7 2.2 12.3 2.2 18 0M10 13h4" />
      </svg>
    );
  }
  if (type === "globe") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="10" r="6" />
        <path d="M12 4c2.1 2.2 2.1 9.8 0 12M12 4c-2.1 2.2-2.1 9.8 0 12M6.4 8h11.2M6.4 12h11.2M12 16v4M9 20h6" />
      </svg>
    );
  }
  if (type === "shield") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3.5c2.2 2 4.8 3.1 7.5 3.3v4.5c0 4.8-3 8.2-7.5 9.7-4.5-1.5-7.5-4.9-7.5-9.7V6.8C7.2 6.6 9.8 5.5 12 3.5Z" />
        <path d="m9 12 2 2 4-4" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m3 9 9-4 9 4-9 4-9-4Z" />
      <path d="M6.5 11.2v5.2c3.3 2 7.7 2 11 0v-5.2M21 9v6" />
    </svg>
  );
}

function Home() {
  const [slide, setSlide] = useState(0);
  const [menu, setMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSection, setMobileSection] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const touchStart = useRef(0);
  const accreditation = [
    { title: "NAAC", logo: naacLogo },
    { title: "AIU", logo: aiuLogo },
    { title: "AACSB", logo: aacsbLogo },
    { title: "UGC", logo: ugcLogo },
    { title: "AICTE", logo: aicteLogo },
    { title: "PCI", logo: pciLogo },
    { title: "BCI", logo: bciLogo },
  ];

  useEffect(() => {
    const timer = window.setInterval(
      () => setSlide((s) => (s + 1) % slides.length),
      9500,
    );
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  const allSchools = [];

  menuData.Programmes.groups.forEach(element => {
    element.links.forEach(link => {
      allSchools.push(link);
    })
  });

  const [activeGroup, setActiveGroup] = useState(
    menuData.Programmes.groups[0]
  );

  const [activeSchool, setActiveSchool] = useState(allSchools[0]);
  const [hoveredSchool, setHoveredSchool] = useState(null);

  useEffect(() => {
    if (menu === "Programmes") {
      setActiveSchool(allSchools[0]);
    }
  }, [menu]);

  const go = (n) => setSlide((n + slides.length) % slides.length);
  return (
    <main>
      <header
        className={`site-header ${scrolled ? "is-scrolled" : ""}`}
        onMouseLeave={() => setMenu(null)}
      >
        <div className="nav-shell">
          <a className="brand" href="/" aria-label="ISBM University home">
            <img src={logoWhite} className="brand-logo" alt="ISBM University" />
          </a>

          <div className="nav-stack">
            <div className="utility-bar">
              <nav aria-label="Utility navigation">
                {utilityLinks.map((link) => (
                  <a key={link.title} href={link.url}>
                    {link.title}
                  </a>
                ))}
              </nav>

              <div className="utility-actions">
                <a href="tel:+919373199999" className="phone">
                  <span>Call us</span> +91 93731 99999
                </a>

                <a href="/apply" className="utility-apply">
                  Apply Online <span>↗</span>
                </a>
              </div>
            </div>

            <nav className="primary-nav" aria-label="Primary navigation">
              {Object.keys(menuData).map((item) => (
                <button
                  key={item}
                  className={menu === item ? "active" : ""}
                  onMouseEnter={() => setMenu(item)}
                  onFocus={() => setMenu(item)}
                  aria-expanded={menu === item}
                >
                  {item}
                  <span>
                    <i className="ti ti-chevrons-down"></i>
                  </span>
                </button>
              ))}

              <button className="search-btn" aria-label="Search">
                <svg viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="6.5" />
                  <path d="m16 16 4 4" />
                </svg>
              </button>
            </nav>
          </div>

          <div className="mobile-actions">
            <a href="/apply" className="mini-apply">
              Apply
            </a>

            <button
              className={`menu-toggle ${mobileOpen ? "open" : ""}`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-expanded={mobileOpen}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>

        <div
          className={`mega-menu ${menu ? "open" : ""}`}
          role="region"
          aria-label="Navigation submenu"
        >
          {menu && (
            <div className="mega-inner" key={menu}>
              <div className="mega-intro">
                <span className="mega-eyebrow">{menuData[menu].eyebrow}</span>

                <h2>{menuData[menu].title}</h2>

                <p>{menuData[menu].description}</p>

                <a href={menuData[menu].url || "#"}>
                  Overview <span>→</span>
                </a>
              </div>

              {menu === "Programmes" ? (
                <>
                  <div className="mega-group mega-relative">
                    <h3>{menuData.Programmes.groups[0].title}</h3>

                    {menuData.Programmes.groups[0].links.map((school) => (
                      <div
                        key={school.url}
                        className="school-item"
                        onMouseEnter={() => setHoveredSchool(school)}
                        onMouseLeave={() => setHoveredSchool(null)}
                      >
                        <a href={school.url}>
                          {school.title}
                          {school.courses && <span>›</span>}
                        </a>

                        {hoveredSchool?.url === school.url &&
                          school.courses?.length > 0 && (
                            <div className="course-dropdown">
                              {school.courses.map(course => (
                                <a key={course.url} href={course.url}>
                                  {course.title}
                                </a>
                              ))}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                  <div className="mega-group mega-relative-2">
                    <h3>{menuData.Programmes.groups[1].title}</h3>

                    {menuData.Programmes.groups[1].links.map((school) => (
                      <div
                        key={school.url}
                        className="school-item"
                        onMouseEnter={() => setHoveredSchool(school)}
                        onMouseLeave={() => setHoveredSchool(null)}
                      >
                        <a href={school.url}>
                          {school.title}
                          {school.courses && <span>›</span>}
                        </a>

                        {hoveredSchool?.url === school.url &&
                          school.courses?.length > 0 && (
                            <div className="course-dropdown">
                              {school.courses.map(course => (
                                <a key={course.url} href={course.url}>
                                  {course.title}
                                </a>
                              ))}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                menuData[menu].groups.map((group) => (
                  <div className="mega-group" key={group.title}>
                    <h3>{group.title}</h3>

                    {group.links.map((link) => (
                      <a key={link.url} href={link.url}>
                        {link.title}
                      </a>
                    ))}
                  </div>
                ))
              )}

              <a href={menuData[menu].url || "#"} className="mega-feature">
                <img src={menuData[menu].image} alt={menu} />

                <span>
                  <small>Featured</small>
                  <strong>Experience our university</strong>
                  <i>Explore now →</i>
                </span>
              </a>
            </div>
          )}
        </div>
      </header>

      <div
        className={`mobile-panel ${mobileOpen ? "open" : ""}`}
        aria-hidden={!mobileOpen}
      >
        <div className="mobile-utility">
          {utilityLinks.map((link) => (
            <a key={link.url} href={link.url}>
              {link.title}
            </a>
          ))}

          <a href="tel:+919373199999">Call Us</a>
        </div>

        <nav aria-label="Mobile navigation">
          {Object.entries(menuData).map(([item, data]) => (
            <div className="mobile-menu-item" key={item}>
              <button
                onClick={() =>
                  setMobileSection(mobileSection === item ? null : item)
                }
                aria-expanded={mobileSection === item}
              >
                {item}
                <span>{mobileSection === item ? "−" : "+"}</span>
              </button>

              <div
                className={`mobile-sub ${mobileSection === item ? "open" : ""}`}
              >
                {data.groups.map((group) => (
                  <div className="mobile-sub-group" key={group.title}>
                    <h6>{group.title}</h6>

                    {group.links.map((link) => (
                      <a href={link.url} key={link.url}>
                        {link.title}
                      </a>
                    ))}
                  </div>
                ))}

                <a href={data.url} className="mobile-overview">
                  View {item} →
                </a>
              </div>
            </div>
          ))}
        </nav>

        <a className="mobile-cta" href="/apply">
          Begin your application <span>→</span>
        </a>
      </div>

      <section
        id="main-content"
        className="hero"
        aria-label="University highlights"
        onTouchStart={(e) => (touchStart.current = e.touches[0].clientX)}
        onTouchEnd={(e) => {
          const d = e.changedTouches[0].clientX - touchStart.current;
          if (Math.abs(d) > 45) go(slide + (d < 0 ? 1 : -1));
        }}
      >
        {slides.map((s, i) => (
          <article
            className={`slide ${i === slide ? "active" : ""}`}
            key={i}
            aria-hidden={i !== slide}
          >
            <img className="slide-image" src={s.image} alt={s.alt} />
            <div className="slide-overlay" />
            <div className="hero-content">
              <div className="hero-rule" />
              <p className="kicker">{s.kicker}</p>
              <h1>{s.title}</h1>
              <p className="hero-text">{s.text}</p>
              <div className="hero-buttons">
                <a href="#" className="btn-primary">
                  {s.primary}
                  <span>→</span>
                </a>
                <a href="#" className="btn-ghost">
                  {s.secondary}
                  <span>↗</span>
                </a>
              </div>
            </div>
          </article>
        ))}
        <div className="hero-controls">
          <button onClick={() => go(slide - 1)} aria-label="Previous slide">
            ←
          </button>
          <div className="slide-indicators">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => go(i)}
                className={i === slide ? "active" : ""}
                aria-label={`Go to slide ${i + 1}`}
              >
                <span />
              </button>
            ))}
          </div>
          <button onClick={() => go(slide + 1)} aria-label="Next slide">
            →
          </button>
          <span className="slide-count">
            0{slide + 1} <i /> 0{slides.length}
          </span>
        </div>
        <a className="scroll-cue" href="#explore">
          <span>Scroll to explore</span>
          <i>↓</i>
        </a>
        <aside className="hero-note">
          <small>Explore our campus</small>
          <strong>Book a guided visit</strong>
          <a href="#" aria-label="Book a guided campus visit">
            ↗
          </a>
        </aside>
      </section>

      <section
        className="about-section"
        id="explore"
        aria-labelledby="about-heading"
      >
        <div className="container mx-auto">
          <div
            className="recognition-strip"
            aria-label="Accreditations and memberships"
          >
            {recognitions.map((item, index) => (
              <article className="recognition-item" key={item.mark}>
                <div className="recognition-mark" aria-hidden="true">
                  <span>{item.mark}</span>
                  <small>{index === 0 ? "Accredited" : "Member"}</small>
                </div>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </article>
            ))}
          </div>
          <div className="about-shell">
            <div
              className="about-visual"
              aria-label="Students learning at ISBM University"
            >
              <figure className="about-photo about-photo-primary">
                <img
                  src={about1}
                  alt="ISBM University students walking together on campus"
                />
              </figure>
              <figure className="about-photo about-photo-secondary">
                <img
                  src={about2}
                  alt="Students collaborating during an academic activity"
                />
              </figure>
              <div className="about-seal" aria-hidden="true">
                <strong>NAAC</strong>
                <span>Accredited</span>
              </div>
            </div>
            <div className="about-content">
              <div className="section-eyebrow">
                <span /> Explore what makes us exceptional
              </div>
              <h2 id="about-heading">
                A Legacy of <em>Excellence</em> &amp; Growth
              </h2>
              <p className="about-lead">
                ISBM University supports the complete student journey—combining
                purposeful learning with career development, skill enhancement,
                entrepreneurship and mentoring.
              </p>
              <p>
                Established and approved by the Government of Chhattisgarh under
                the Chhattisgarh Private Universities (Establishment and
                Operation) Act, 2005 (Amendment Act 2016), the University is
                empowered to confer degrees, diplomas and certificates.
              </p>
              <div className="feature-grid">
                {differentiators.map((item) => (
                  <a className="feature-card" href="#" key={item.title}>
                    <span className="feature-icon">
                      <FeatureIcon type={item.icon} />
                    </span>
                    <span className="feature-copy">
                      <strong>{item.title}</strong>
                      <small>{item.description}</small>
                      <b>
                        Discover more <i>↗</i>
                      </b>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="stats-panel">
            <div className="stats-heading">
              <span>ISBM University at a glance</span>
              <h2>
                One of the <em>Top Private Universities</em> in Chhattisgarh
              </h2>
            </div>
            <div className="stats-grid">
              {universityStats.map((item) => (
                <article className="stat-item" key={item.value}>
                  <strong>{item.value}</strong>
                  <p>{item.label}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="programmes-section" id="programmes">
        <div className="container mx-auto">
          <div className="programmes-shell">
            <div className="programmes-intro">
              <div className="section-eyebrow">
                <span></span>
                Find your academic pathway
              </div>
              <h2>
                Discover Career-Driven <em>Study Options</em>
                That Empower Your Ambitions
              </h2>
              <p>
                ISBM University offers a wide range of academic programmes that
                combine theoretical foundations with real-world applications.
                From undergraduate to doctoral levels, our curriculum equips
                students with the skills required to thrive in a competitive
                global environment.
              </p>
              <p>
                Every programme emphasizes research, innovation and holistic
                development. Students gain mentorship, industry exposure and
                opportunities for practical learning and entrepreneurship.
              </p>
              <div className="arrow-container">
                <img alt="Arrow" className="arrow-image" src={arrow} />
                <a className="programmes-cta" href="#">
                  <span>View all programmes</span>
                  <i>↗</i>
                </a>
              </div>
            </div>
            <div className="programmes-gallery">
              <div className="programmes-column programmes-column-left">
                <a className="programme-card programme-card-wide" href="#">
                  <img src={p1} alt="Research and development" />
                  <span className="programme-overlay"></span>
                  <span className="programme-copy">
                    <small>Create new knowledge</small>
                    <strong>Research and Development</strong>
                    <b>
                      View programme <i>↗</i>
                    </b>
                  </span>
                </a>
                <a className="programme-card programme-card-wide" href="#">
                  <img src={p2} alt="Post graduation" />
                  <span className="programme-overlay"></span>
                  <span className="programme-copy">
                    <small>Advance your expertise</small>
                    <strong>Post Graduation</strong>
                    <b>
                      View programme <i>↗</i>
                    </b>
                  </span>
                </a>
              </div>
              <div className="programmes-column">
                <a className="programme-card" href="#">
                  <img src={p3} alt="Graduation" />
                  <span className="programme-overlay"></span>
                  <span className="programme-copy">
                    <small>Build your foundation</small>
                    <strong>Graduation</strong>
                    <b>
                      View programme <i>↗</i>
                    </b>
                  </span>
                </a>
                <a className="programme-card" href="#">
                  <img src={p4} alt="Diploma" />
                  <span className="programme-overlay"></span>
                  <span className="programme-copy">
                    <small>Develop practical skills</small>
                    <strong>Diploma</strong>
                    <b>
                      View programme <i>↗</i>
                    </b>
                  </span>
                </a>
                <a className="programme-card" href="#">
                  <img src={p5} alt="Certificate" />
                  <span className="programme-overlay"></span>
                  <span className="programme-copy">
                    <small>Learn with flexibility</small>
                    <strong>Certificate</strong>
                    <b>
                      View programme <i>↗</i>
                    </b>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="recognition-section">
        <div className="recognition-title">
          <h2>
            Approvals &<br />
            Accreditations
          </h2>
        </div>
        <div className="recognition-slider">
          <div className="recognition-track">
            {[...accreditation, ...accreditation].map((item, index) => (
              <div className="recognition-box" key={index}>
                <div className="recognition-logo">
                  <img src={item.logo} alt={item.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Programmes />

      <section className="apply-cta">
        <div className="container mx-auto">
          <div className="apply-cta-content">
            <span className="cta-tag">ADMISSIONS OPEN • 2026</span>
            <h2>
              Ready to Build Your
              <em> Future?</em>
            </h2>
            <p>
              Join ISBM University and become part of an academic community
              committed to innovation, research, leadership, and lifelong
              learning. Applications are now open for Undergraduate,
              Postgraduate, Diploma and Doctoral programmes.
            </p>
            <div className="cta-buttons">
              <a href="/apply-now" className="cta-primary">
                Apply Now
              </a>
              <a href="/admissions" className="cta-secondary">
                Download Prospectus
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="partnership-section">
        <div className="container mx-auto">
          <div className="partnership-wrapper">
            <div className="partnership-content">
              <div className="section-eyebrow">
                <span></span>
                GLOBAL COLLABORATIONS
              </div>
              <h2>
                International Partnerships –
                <em> Making Connections that Span the Globe</em>
              </h2>
              <p>
                The primary objective of the International Tie-ups is to promote
                internationalization and cross-cultural exchange in the academic
                realm. These partnerships foster global academic and research
                opportunities for students, faculty and staff members of ISBM
                University.
              </p>
              <p>
                Through these collaborations, ISBM University provides students
                with exposure to international educational practices, diverse
                perspectives and multicultural learning environments. The
                partnerships also encourage joint research, faculty exchange
                programmes and academic collaborations with renowned
                universities across the world.
              </p>
            </div>
            <div className="partnership-logos rows-col-2">
              <div className="w-1/2 p-3">
                <div className="logo-card">
                  <img src={abertayLogo} alt="Abertay University" />
                </div>
              </div>
              <div className="w-1/2 p-3">
                <div className="logo-card">
                  <img src={diuLogo} alt="Dresden International University" />
                </div>
              </div>
              <div className="w-1/2 p-3">
                <div className="logo-card">
                  <img src={henryLogo} alt="Henry Harvin" />
                </div>
              </div>
              <div className="w-1/2 p-3">
                <div className="logo-card">
                  <img src={indianaLogo} alt="Indiana Tech" />
                </div>
              </div>
              <div className="w-1/2 p-3">
                <div className="logo-card">
                  <img src={rushfordLogo} alt="Rushford Business School" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="placement-section">
        <div className="container mx-auto">
          <div className="placement-wrapper">
            <div className="placement-content">
              <div className="section-eyebrow">
                <span></span>
                PLACEMENTS
              </div>

              <h2>
                Launch Your Career
                <em> with Confidence</em>
              </h2>

              <p className="placement-introduction">
                ISBM University bridges academic excellence with industry
                expectations through dedicated placement assistance, corporate
                partnerships, internships, career counselling, skill development
                and campus recruitment drives conducted throughout the year.
              </p>

              <div
                className="placement-stats"
                aria-label="Placement statistics"
              >
                {placementStats.map((stat, index) => (
                  <AnimatedStat
                    key={stat.label}
                    value={stat.value}
                    suffix={stat.suffix}
                    label={stat.label}
                    index={index}
                  />
                ))}
              </div>

              <a href="/placements" className="placement-btn">
                <span>Explore Placements</span>
                <i>→</i>
              </a>
            </div>

            <div className="placement-gallery">
              {placementGallery.map((image, index) => (
                <figure
                  className={`placement-gallery-item placement-gallery-item--${index + 1
                    }`}
                  key={index}
                >
                  <img
                    src={image}
                    alt={`ISBM University placement activity ${index + 1}`}
                    loading="lazy"
                  />

                  <figcaption>
                    <span>
                      {index === 0 && "Career Readiness"}
                      {index === 1 && "Industry Interaction"}
                      {index === 2 && "Placement Drives"}
                      {index === 3 && "Student Success"}
                    </span>

                    <small>{String(index + 1).padStart(2, "0")}</small>
                  </figcaption>
                </figure>
              ))}

              <div className="placement-gallery-badge">
                <span>Career-focused</span>
                <strong>Learning</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Recruiters />
      <Alumni />
      <Awards />
      <Facilities />
      <BlogsFAQ />
      <NewslettersSection />
      <EventsSection />
      <CircularsNoticesSection />
      <Footer />
    </main>
  );
}

export default Home;
